import styled from 'styled-components';

export const RangePickerWrapper = styled.div`
  width: 100%;

  .ant-calendar-picker-icon {
    color: ${({ theme }) => theme.text.formIcon};
  }
`;
